<template>
  <div class="flex" v-if="isManager">
    <nested-menu-tab-button :title="$t('members')" icon="icon-users" route="members"></nested-menu-tab-button>
    &nbsp;
    <nested-menu-tab-button :title="$t('import_members')" icon="icon-upload" route="member.import"></nested-menu-tab-button>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'
import {EventBus} from '@/../eventbus'

export default {
  name: 'Shared.Messages.TabNav',
  components: {
    NestedMenuTabButton
  },
  methods: {
    openSendSmsPopup () {
      EventBus.$emit('initSendSmsPopup')
    }
  },
  data () {
    return {
      isManager: ''
    }
  },
  mounted () {
    this.isManager = this.$store.getters.isManager
  }
}
</script>

<style scoped>

</style>
